document.addEventListener("DOMContentLoaded", function () {
  if (
    document.body.classList.contains("single-property") ||
    document.body.classList.contains("single-yacht") ||
    document.body.classList.contains("single-car")
  ) {
    const thumbsSlider = new Swiper(".thumbs-slider", {
      slidesPerView: 5,
      spaceBetween: 0,
      watchSlidesProgress: true,
    });

    const mainSlider = new Swiper(".main-slider", {
      spaceBetween: 10,
      autoHeight: true,
      thumbs: {
        swiper: thumbsSlider,
      },
    });

    lightGallery(document.getElementById("lightgallery"), {
      selector: "a",
      download: false,
      zoom: true,
      fullscreen: true,
      thumbnail: true,
    });
  }

  if (document.body.classList.contains("single")) {
    const relatedSlider = new Swiper(".related-slider", {
      loop: false,
      slidesPerView: 3,
      spaceBetween: 20,
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
    });
  }
});
